var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"list-item repair",class:{'has-cid': _vm.$route.name==='allVis' && _vm.cId}},[_c('x-angleIcon'),_vm._m(0),_c('div',{staticClass:"tongji iconfont iconicon_tongji"}),_c('div',{attrs:{"id":"repair"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h3',[_c('i',{staticClass:"iconfont iconicon_jiantou"}),_vm._v("报修统计")])
}]

export { render, staticRenderFns }